import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

export function createGLBModel({
  id,
  name,
  url,
  transform = {},
  capabilities = {},
  geometryProcessor = null,
}) {
  return {
    id,
    name,

    type: "gltf",

    url,

    transform: {
      position: [0, 0, 0],

      rotation: [0, 0, 0],

      scale: 1.0,

      ...transform,
    },

    capabilities: {
      normals: true,
      uv: true,
      tangents: false,

      ...capabilities,
    },

    async loadMeshes() {
      const loader = new GLTFLoader();

      const gltf = await loader.loadAsync(url);

      /*
       * Make sure every node's matrixWorld
       * reflects the complete GLTF hierarchy.
       */
      gltf.scene.updateMatrixWorld(true);

      const meshes = [];

      gltf.scene.traverse((object) => {
        if (!object.isMesh || !object.geometry) {
          return;
        }

        const geometry = object.geometry.clone();

        /*
         * Bake the GLTF node hierarchy into
         * this geometry.
         */
        geometry.applyMatrix4(object.matrixWorld);

        /*
         * Optional model-specific geometry
         * preprocessing.
         *
         * This lets models add attributes such
         * as curvature/hatching directions
         * without coupling GLBModel to a
         * particular rendering technique.
         */
        const processedGeometry = geometryProcessor
          ? geometryProcessor(geometry)
          : geometry;

        /*
         * A processor is allowed to return a
         * new BufferGeometry. If it does,
         * dispose the temporary clone.
         */
        if (processedGeometry !== geometry) {
          geometry.dispose();
        }

        meshes.push({
          name: object.name || `Mesh ${meshes.length + 1}`,

          geometry: processedGeometry,
        });
      });

      if (meshes.length === 0) {
        throw new Error(`No mesh geometry found in ${url}`);
      }

      return meshes;
    },
  };
}
